import { Utils } from "./Utils";
import { ILaya } from "../../ILaya";
export class WeakObject {
    static get I() {
        return this._i || (this._i = new WeakObject());
    }
    static clearCache() {
        for (let i = 0, n = WeakObject._maps.length; i < n; i++) {
            let obj = WeakObject._maps[i];
            obj._obj = {};
        }
    }
    constructor() {
        this._obj = {};
        if (!WeakObject._maps) {
            WeakObject._maps = [this];
            ILaya.systemTimer.loop(WeakObject.delInterval, null, WeakObject.clearCache);
        }
        else
            WeakObject._maps.push(this);
    }
    set(key, value) {
        if (key == null)
            return;
        if (typeof (key) == 'string' || typeof (key) == 'number') {
            this._obj[key] = value;
        }
        else {
            this._obj[Utils.getGID(key)] = value;
        }
    }
    get(key) {
        if (key == null)
            return null;
        if (typeof (key) == 'string' || typeof (key) == 'number')
            return this._obj[key];
        else
            return this._obj[Utils.getGID(key)];
    }
    del(key) {
        if (key == null)
            return;
        if (typeof (key) == 'string' || typeof (key) == 'number')
            delete this._obj[key];
        else
            delete this._obj[Utils.getGID(key)];
    }
    has(key) {
        if (key == null)
            return false;
        if (typeof (key) == 'string' || typeof (key) == 'number')
            return this._obj[key] != null;
        else
            return this._obj[Utils.getGID(key)] != null;
    }
}
WeakObject.delInterval = 10 * 60 * 1000;
